import React, { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';



export const Mailer = () => {

    const [formData, setFormData] = useState({});
    const form = useRef();
    const toast = useRef(null);

    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);



    const formik = useFormik({
        initialValues: {
            nom: `${user_connect.prenom} ${user_connect.nom}`,
            matricule: `${user_connect.numcont}`,
            tel: `${user_connect.portable}`,
            email: `${user_connect.email}`,
            objet: '',
            message: ''

        },
        validate: (data) => {
            let errors = {};

            if (!data.nom) {
                errors.nom = 'Le Nom est requis.';
            }

            if (!data.matricule) {
                errors.matricule = 'Le Matricule est requis.';
            }

            if (!data.message) {
                errors.message = 'Le message est requis.';
            }

            if (!data.email) {
                errors.email = 'Email est requis.';
            }
            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.email)) {
                errors.email = 'Adresse Email Invalide. E.x. example@email.com';
            }

            return errors;
        },

        onSubmit: (data) => {
            setFormData(data);

            emailjs.sendForm('service_la0h8w5', 'template_v8iujqb', form.current, 'rtWXeD_UKWkV7vCuF')
                .then((result) => {
                    console.log(result.text);

                    toast.current.show({
                        severity: 'info',
                        summary: 'Envoi Mail',
                        detail: 'Votre message a été envoyé avec succès !',
                        life: 5000,
                        style: { with: '100px' }
                    });
                }, (error) => {
                    console.log(error.text);

                    toast.current.show({
                        severity: 'error',
                        summary: 'Envoi Mail',
                        detail: 'Erreure survenue !!!',
                        life: 5000,
                        style: { with: '100px' }
                    });
                });

            formik.resetForm();
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };


    return (

        <>
            <Toast ref={toast} />

            <div className="surface-0 p-4 shadow-2 border-round">
                <div className="text-3xl font-medium text-900 mb-3">Contactez-nous</div>
                <div className="font-medium text-800 mb-3">Pour toutes informations, vous pouvez appelez sur les numéros qui figurent sur les bons ou nous envoyez un message via ce formulaire</div>
                <div className="border-2 border-dashed border-300">
                    <form ref={form} onSubmit={formik.handleSubmit} >

                        <div className='p-fluid grid formgrid mt-5'>
                            <div className="field col-12 md:col-4">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <InputText id="objet" name="objet" value={formik.values.objet} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('objet') })} />
                                        <label htmlFor="objet" className={classNames({ 'p-error': isFormFieldValid('objet') })}>Objet</label>
                                    </span>
                                    {getFormErrorMessage('objet')}
                                </div>
                            </div>
                        </div>
                        <div className='p-fluid grid formgrid mt-3'>
                            <div className="field col-12 md:col-4">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <InputText id="nom" name="nom" value={formik.values.nom} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('nom') })} readOnly />
                                        <label htmlFor="nom" className={classNames({ 'p-error': isFormFieldValid('nom') })}>Nom*</label>
                                    </span>
                                    {getFormErrorMessage('nom')}
                                </div>
                            </div>
                        </div>
                        <div className='p-fluid grid formgrid mt-3'>
                            <div className="field col-12 md:col-4">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <InputText id="matricule" name="matricule" value={formik.values.matricule} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('matricule') })} readOnly />
                                        <label htmlFor="matricule" className={classNames({ 'p-error': isFormFieldValid('matricule') })}>Matricule*</label>
                                    </span>
                                    {getFormErrorMessage('matricule')}
                                </div>
                            </div>
                        </div>
                        <div className='p-fluid grid formgrid mt-3'>
                            <div className="field col-12 md:col-4">
                                <div className="p-field">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-envelope" />
                                        <InputText id="email" name="email" value={formik.values.email} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('email') })} />
                                        <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>Email*</label>
                                    </span>
                                    {getFormErrorMessage('email')}
                                </div>
                            </div>
                        </div>
                        <div className='p-fluid grid formgrid mt-3'>
                            <div className="field col-12 md:col-4">
                                <div className="p-field">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-mobile" />
                                        <InputText id="tel" name="tel" value={formik.values.tel} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('tel') })} />
                                        <label htmlFor="tel" className={classNames({ 'p-error': isFormFieldValid('tel') })}>Téléphone</label>
                                    </span>
                                    {getFormErrorMessage('tel')}
                                </div>
                            </div>
                        </div>
                        <div className='p-fluid grid formgrid mt-3'>
                            <div className="field col-12 md:col-6">
                                <div className="p-field">
                                    <span className="p-float-label ">
                                        <InputTextarea rows={4} cols={30} id="message" name="message" value={formik.values.message} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('message') })} />
                                        <label htmlFor="message" className={classNames({ 'p-error': isFormFieldValid('message') })}>Message*</label>
                                    </span>
                                    {getFormErrorMessage('message')}
                                </div>
                            </div>
                        </div>

                        <div className='p-fluid grid formgrid'>

                            <div className="field col-12 md:col-6">
                                <Button type="submit" label="Envoyer votre message" icon="pi pi-inbox" className="w-full" />
                            </div>

                        </div>

                    </form>
                </div>
            </div>
        </>


    );


};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Mailer, comparisonFn);